import axios from 'axios';
const cancelToken = axios.CancelToken;
const source = cancelToken.source();

const buildHitStreetLink = (payload) => {
    const hitStreetLink = 'https://bkoffers.com/hitstreet/hit_count_hsid2.cfm?' +
        'offer_id=' + payload.OID + '&' +
        'program_id=' + payload.PID + '&' +
        'hsid=' + payload.HSID + '&' +
        'eid=' + payload.EID + '&' +
        'oid=' + payload.OID + '&' +
        'pid=' + payload.PID + '&' +
        'sid=' + payload.SID + '&' +
        'uid=' + payload.UID;
    return hitStreetLink;
};

const pingHitStreet = async(payload) => {
    try{
        const fetchLink = buildHitStreetLink(payload);
        const res = await axios({
            method: 'get',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            url: fetchLink,
            cancelToken: source.token
        });
        if (res.status !== 200) {
            const backup = Date.now();
            console.log('Error occured on HitStreet; Fallback ClickID created:', backup);
            return backup;
        };
        if(typeof res.data === 'number') {
            console.log('New HSID fetched:', res.data);
            return res.data;
        };
        console.log('HSID passed in URL:', Number(payload.HSID));
        return payload.HSID;
        
    } catch(err) {
        if (axios.isCancel(err)) {
            return {status: 'failed', message: 'axios hitstreet request cancelled'};
        }
        return {status: 'failed', message: err};
    }
};

export default pingHitStreet;